/**
 * Initialize the text editor.
 */
export function initializeTextEditor() {
    let theme = $('body').data('theme');
    if (typeof tinyMCE !== 'undefined') {
        tinymce.remove();
        tinymce.init({
            paste_data_images: false,
            ui_mode: 'split',
            selector: 'textarea.text-editor',
            menu: {
                format: {title: 'Format', items: 'forecolor'}
            },
            skin: (theme === 'dark' ? 'oxide-dark' : 'oxide'),
            content_css: (theme === 'dark' ? 'dark' : 'default'),
            elementpath: false,
            statusbar: true,
            relative_urls: false, convert_urls: false, remove_script_host: false,
            plugins: [
                'advlist', 'autolink', 'lists', 'link', 'image', 'charmap', 'preview',
                'anchor', 'searchreplace', 'visualblocks', 'fullscreen',
                'insertdatetime', 'media', 'table', 'help', 'wordcount', 'autoresize'
            ],
            toolbar: 'undo redo | fontfamily fontsize blocks | ' +
                'superscript subscript bold underline italic backcolor forecolor link image | alignleft aligncenter ' +
                'alignright alignjustify | bullist numlist outdent indent | ' +
                'removeformat | table tabledelete | tableprops tablerowprops tablecellprops | '
                + 'tableinsertrowbefore tableinsertrowafter tabledeleterow |'
                + 'tableinsertcolbefore tableinsertcolafter tabledeletecol |help',
            contextmenu: 'paste | bold italic underline link image undo redo | removeformat fullscreen',
            menubar: false,
            min_height: 300,
            autoresize: true,
            block_formats: 'Paragraph=p; Heading 1=h1; Heading 2=h2; Heading 3=h3; Heading 4=h4; Heading 5=h5; Heading 6=h6',
            image_title: true,
            image_dimensions: false,
            media_alt_source: false,
            media_dimensions: false,
            preview_styles: false,
            importcss_append: false,
            link_default_protocol: 'https',
            link_assume_external_targets: true,
            default_link_target: '_blank',
            paste_as_text: true,
            formats: {
                bold: [
                    {inline: 'strong', remove: 'all'},
                ],
                italic: [
                    {inline: 'em', remove: 'all'},
                ],
                underline: [
                    {inline: 'u', remove: 'all'},
                ],
            },
            setup: function (editor) {
                editor.on('change', function () {
                    editor.save();
                });
                editor.on('OpenWindow', function (e) {
                    // This prevents weirdness between the Bootstrap modal and the TinyMCE popup window.
                    // https://stackoverflow.com/a/36286459.
                    $(document).off('focusin.modal');
                });
            }
        });
    }

    document.addEventListener('focusin', function (e) {
        if (e.target.closest && e.target.closest(".tox-tinymce-aux, .moxman-window, .tam-assetmanager-root") !== null) {
            e.stopImmediatePropagation();
        }
    });
}
